export interface SessionUser {
  id: number;
  uuid: string;
  username: string;
  role: "admin" | "user";
}

export interface SessionResponse {
  authenticated: boolean;
  user: SessionUser | null;
}

export async function getSession(): Promise<SessionResponse> {
  const response = await fetch("/api/auth/session", {
    credentials: "include",
  });
  return response.json();
}

export async function login(
  username: string,
  password: string,
): Promise<SessionResponse> {
  const response = await fetch("/api/auth/login", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!response.ok) {
    throw new Error("Invalid username or password");
  }
  return response.json();
}

export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
  });
}
